import { render, staticRenderFns } from "./companyCard1.vue?vue&type=template&id=60c5ad22&scoped=true"
import script from "./companyCard1.vue?vue&type=script&lang=js"
export * from "./companyCard1.vue?vue&type=script&lang=js"
import style0 from "./companyCard1.vue?vue&type=style&index=0&id=60c5ad22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c5ad22",
  null
  
)

export default component.exports